import React, { Component } from "react";
import Spinner from "../Spinner";
import NoData from "./noData";

class TableLoader extends Component {
  render() {
    return (
      <>
        {this.props.isLoading ? (
          // <div className="d-flex justify-content-center table-loader">
          //   <div className="spinner-border text-primary" role="status">
          //     <span className="sr-only">Loading...</span>
          //   </div>
          // </div>
     <span className="text-primaryColor">
           <Spinner  size={24} />
     </span>
        ) : this.props.dataLength === 0 ? (
            <div className="translate-y-4">
              <NoData
                moduleName={this.props.moduleName}
                customMessage={this.props.customMessage}
              />
            </div>
        ) : (
          ""
        )}
      </>
    );
  }
}

export default TableLoader;
